import type { AnchorHTMLAttributes, ReactNode } from "react";
import { isExternal, navigateTo } from "../lib/navigation";

type SmartLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "onClick"> & {
  href: string;
  children: ReactNode;
  onClick?: () => void;
};

export function SmartLink({ href, children, className, onClick, ...props }: SmartLinkProps) {
  if (isExternal(href)) {
    const opensNewTab = href.startsWith("http://") || href.startsWith("https://");
    return (
      <a
        href={href}
        className={className}
        target={opensNewTab ? "_blank" : undefined}
        rel={opensNewTab ? "noreferrer" : undefined}
        onClick={onClick}
        {...props}
      >
        {children}
      </a>
    );
  }

  return (
    <a
      href={href}
      className={className}
      onClick={(event) => {
        event.preventDefault();
        onClick?.();
        navigateTo(href);
      }}
      {...props}
    >
      {children}
    </a>
  );
}
